/**
 * @generated SignedSource<<bc2d24c2ae60446049fba67994183e61>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductVideoRefetch_viewer$data = {
  readonly video: {
    readonly url: string | null;
    readonly videoProvider: string | null;
    readonly vimeoUrl: string | null;
  } | null;
  readonly " $fragmentType": "ProductVideoRefetch_viewer";
};
export type ProductVideoRefetch_viewer$key = {
  readonly " $data"?: ProductVideoRefetch_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductVideoRefetch_viewer">;
};

import ProductVideoRefetchQuery_graphql from './ProductVideoRefetchQuery.graphql';

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "itemId"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "viewer"
      ],
      "operation": ProductVideoRefetchQuery_graphql
    }
  },
  "name": "ProductVideoRefetch_viewer",
  "selections": [
    {
      "alias": "video",
      "args": [
        {
          "kind": "Variable",
          "name": "itemId",
          "variableName": "itemId"
        }
      ],
      "concreteType": "ItemVideo",
      "kind": "LinkedField",
      "name": "itemVideoV2",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "vimeoUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "videoProvider",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "217c395940f14ad30caa6cbba3e8de7f";

export default node;
